export const GET_HIDDEN_TAGS = 'GET_HIDDEN_TAGS';
export const GET_HIDDEN_TAGS_SUCCESS = 'GET_HIDDEN_TAGS_SUCCESS';

export const DELETE_HIDDEN_TAG = 'DELETE_HIDDEN_TAG';

export const HIDE_TAGS = 'HIDE_TAGS';



// WEBPACK FOOTER //
// ./src/actionTypes/hiddenTagActionTypes.js